'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarBannerSegment = renderWithRef('PriceBarBannerSegment', null, (n, t)=>{
    let { children: a } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: new Set([
            'swan-price-bar-banner-segment'
        ]),
        props: n,
        children: a
    });
});

export { PriceBarBannerSegment };
